import { useState, useEffect } from "react";
import axios from "../axiosConfig";  // Import the global axios instance
import { useNavigate } from "react-router-dom";
import "./Login.css";

const Login = () => {
  const [email, setEmail] = useState("");
  const [message, setMessage] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  useEffect(() => {
    const checkIfLoggedIn = async () => {
      try {
        const response = await axios.get("/api/session/"); 
        if (response.status === 200) {
          navigate("/main");
        }
      } catch (error) {
        console.log("User not logged in", error);
      }
    };

    checkIfLoggedIn();
  }, [navigate]);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);

    try {
      const response = await axios.get("/api/link/", { 
        params: { email } 
      });
      setMessage(response.data.message);
    } catch (error) {
      console.error("Error:", error);
      setMessage(`Error sending sign-in link: ${error.response?.data?.message || error.message}`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="login-container">
      <form onSubmit={handleSubmit} className="login-form">
        {/*<img src={`${process.env.PUBLIC_URL}/logo192.png`} alt="Logo" className="logo"/>*/}
        <h2>PERL Portal</h2>
        <input
          type="email"
          placeholder="email@progressive-research.com"
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          required
        />
        <button type="submit" disabled={loading}>
          {loading ? "Logging in..." : "Login"}
        </button>
        <p>{message}</p>
      </form>
      
    </div>
  );
};

export default Login;
